// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"SettingsMenuItem_menuItem__ugm6b","menuItemActive":"SettingsMenuItem_menuItemActive__CIB6n","link":"SettingsMenuItem_link__Zg3mr"};